import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=authed

  const checkAuth = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) {
      return; // AuthCallback will handle it
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (first_name, email, password) => {
    const { data } = await api.post("/auth/register", { first_name, email, password });
    setUser(data);
    return data;
  };

  const googleLogin = async (session_id) => {
    const { data } = await api.post("/auth/google", { session_id });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch { return null; }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, googleLogin, logout, refreshUser, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
